import React, { useContext } from 'react'
import { TabMenu, TabMenuButton, View } from 'oio-react'
import { Link, useRouteMatch } from 'react-router-dom'
import { AddIcon } from 'assets/icons'
import { useOrganization } from 'src/core/graphql/hooks'
import { InitiativeHierarchyContext } from 'src/sites/kits/Utils/InitiativeHierarchy'
import { useGlobalState } from 'src/sites/state'

const ObjectViewNav = () => {
   const match = useRouteMatch()
   const { theme } = useGlobalState()

   const { organization } = useOrganization()
   const { highlightColor } = organization.theme

   const { initiative } = useContext(InitiativeHierarchyContext)
   const primaryRole = initiative.roles.find(r => r.type === 'primary')
   const userCanAddPages = ['event', 'group', 'resource'].includes(initiative.class) &&
      initiative.currentUserCanEdit

   // Show all pages (including unpublished) to users that can edit
   const customPages = initiative.currentUserCanEdit
      ? initiative.customPages
      : initiative.customPages.filter(p => p.published)

   const navTabs = [{
      name: `${initiative.type.nameSingular} Home`,
      linkTo: match.url,
      exact: true
   }].concat(customPages.map(page => ({
      name: page.title,
      linkTo: `${match.url}/${page.slug}`,
      exact: true
   })))

   if (['event', 'group'].includes(initiative.class) && primaryRole && initiative.appsPeopleEnabled) {
      navTabs.push({
         name: `${initiative.type.nameSingular} ${primaryRole.name}`,
         linkTo: `${match.url}/-/people`
      })
   }

   if (initiative.class === 'group' && initiative.appsEventsEnabled) {
      navTabs.push({
         name: 'Events',
         linkTo: `${match.url}/-/events`
      })
   }

   if (initiative.class === 'event' && initiative.appsScheduleEnabled) {
      navTabs.push({
         name: 'Schedule',
         linkTo: `${match.url}/-/schedule`
      })
   }

   return (
      <View
         display="flex"
         alignItems="center"
         width="100%"
         marginTop="40px">
         <View float="left" width={initiative.currentUserCanEdit ? 'calc(100% - 40px)' : '100%'}>
            <TabMenu
               backgroundColor={theme.tmpContentBackgroundColor}
               buttonPaddingHorizontal="0px"
               buttonSpacing="25px"
               buttonSize="xl"
               buttonTextSize="1.5[a-b] 2.5[c-f]"
               highlightColor={highlightColor}>
               {navTabs.map(button => (
                  <TabMenuButton
                     key={button.linkTo}
                     name={button.name}
                     linkTo={button.linkTo}
                     linkExact={button.exact}
                  />
               ))}
            </TabMenu>
         </View>
         {userCanAddPages && (
            <View
               display="flex"
               justifyContent="flex-end"
               float="left"
               width="40px">
               <Link to={`${match.url}/-/pages/create`}>
                  <View
                     display="flex"
                     justifyContent="center"
                     alignItems="center"
                     width="30px"
                     height="30px">
                     <AddIcon
                        width="18px"
                        height="18px"
                        color="#888"
                        strokeWidth="2px"
                     />
                  </View>
               </Link>
            </View>
         )}
      </View>
   )
}

export default ObjectViewNav
